import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import HydraClientFactory from "heracles/HydraClientFactory";

import { AppComponent } from "./app.component";
import { NavbarComponent } from "./hydra-navbar/hydra-navbar.component";
import { HydraDiscoveryComponent } from "./hydra-discovery/hydra-discovery.component";
import { HydraDocumentationComponent } from "./hydra-documentation/hydra-documentation.component";
import { HydraBrowserComponent } from "./hydra-browser/hydra-browser.component";
import { HydraHomeComponent } from "./hydra-home/hydra-home.component";

const appRoutes: Routes = [
  { path: "api-documentation", component: HydraDocumentationComponent },
  { path: "browser", component: HydraBrowserComponent },
  { path: "**", component: HydraHomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HydraDiscoveryComponent,
    HydraDocumentationComponent,
    HydraBrowserComponent,
    HydraHomeComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(appRoutes/*, { enableTracing: true }*/)
  ],
  providers: [
    { provide: "HydraClient", useValue: HydraClientFactory.configure().withDefaults().withAllLinks().andCreate() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
